<!-- =========================================================================================
    File Name: Login.vue
    Description: Login Page
    ----------------------------------------------------------------------------------------
    Item Name: Vuexy - Vuejs, HTML & Laravel Admin Dashboard Template
      Author: Pixinvent
    Author URL: http://www.themeforest.net/user/pixinvent
========================================================================================== -->


<template>
  <div
    class="h-screen flex w-full vx-row no-gutter items-center justify-center"
    id="page-login"
  >
    <div class="vx-col sm:w-1/2 md:w-1/2 lg:w-3/4 xl:w-3/5 sm:m-0 m-4">
      <div slot="no-body">
        <div class="vx-row no-gutter justify-center items-center">
          <!-- <div class="vx-col sm:w-full md:w-full lg:w-1/2 d-theme-dark-bg"> -->
          <div class="px-8 pt-8 login-tabs-container">
            <!-- <div class="vx-card__title mb-4 justify-center"> -->
            <!-- <h4 class="mb-4">WELCOME TO KEYPOLL</h4> -->
            <vs-input size="large" placeholder="JoinGame" v-model="gamePin" />
            <!-- <br /> -->
            <div class="social-login-buttons flex flex-wrap items-center mt-4">
              <!-- facebook -->
              <div
                class="bg-facebook pt-3 pb-2 px-4 rounded-lg cursor-pointer mr-4"
                @click="loginWithFacebook"
              >
                <svg
                  aria-hidden="true"
                  focusable="false"
                  data-prefix="fab"
                  data-icon="facebook-f"
                  class="text-white h-4 w-4 svg-inline--fa fa-facebook-f fa-w-9"
                  role="img"
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 264 512"
                >
                  <path
                    fill="currentColor"
                    d="M215.8 85H264V3.6C255.7 2.5 227.1 0 193.8 0 124.3 0 76.7 42.4 76.7 120.3V192H0v91h76.7v229h94V283h73.6l11.7-91h-85.3v-62.7c0-26.3 7.3-44.3 45.1-44.3z"
                  />
                </svg>
              </div>
              <vs-button color="dark" type="relief">Start</vs-button>
            </div>
            <div class="items-center">
              <!-- <vs-button color="success" type="relief">Success</vs-button> -->
            </div>
            <!-- </div> -->
          </div>
          <!-- </div> -->
        </div>
      </div>

      <!-- <vx-card> -->

      <!-- </vx-card> -->
    </div>
  </div>
</template>


<script>
export default {
  data() {
    return {
      gamePin: "",
      //   mycolor2: "#" + ((Math.random() * 0xffffff) << 0).toString(16),
      mycolor: [
        "#FAEB78",
        "#FAF082",
        "#FAF58C",
        "#FAFA96",
        "#FAFAA0",
        "#FAFAAA",
        "#FAFAB4",
        "#FAFABE",
        "#FAFAD2",
        "#FAFAD2",
        "#FFDC3C",
        "#FFE146",
        "#FFE650",
        "#FFEB5A",
        "#FFF064",
        "#FFF56E",
        "#FFFA78",
        "#FFFA82",
        "#FFFF8C",
        "#FFFF96",
        "#FFC81E",
        "#FFD228",
        "#FFD732",
        "#FFDC3C",
        "#FFE146",
        "#FFE650",
        "#FFEB5A",
        "#FFF064",
        "#FFF56E",
        "#FFF978",
        "#FFB400",
        "#FFBE0A",
        "#FFC314",
        "#FFC81E",
        "#FFCD28",
        "#FFD232",
        "#FFD73C",
        "#FFDC46",
        "#FFE150",
        "#FFE65A",
        "#FDCD8C",
        "#FDD296",
        "#FDD7A0",
        "#FDDCAA",
        "#FDE1B4",
        "#FDE6BE",
        "#FDEBC8",
        "#FDF5D2",
        "#FDF5DC",
        "#FDF5E6",
        "#FAC87D",
        "#FACD87",
        "#FAD291",
        "#FAD79B",
        "#FADCA5",
        "#FAE1AF",
        "#FAE6B9",
        "#FAEBC3",
        "#FAEBCD",
        "#FAEBD7",
        "#FFA500",
        "#FFAF0A",
        "#FFB914",
        "#FFC31E",
        "#FFCD28",
        "#FFD732",
        "#FFDC37",
        "#FFE13C",
        "#FFE641",
        "#FFEB46",
        "#FF9100",
        "#FF9B00",
        "#FFA500",
        "#FFAF00",
        "#FFB900",
        "#FFC300",
        "#FFC800",
        "#FFCD00",
        "#FFD200",
        "#FFD700",
        "#FF8200",
        "#FF8C0A",
        "#FF9614",
        "#FFA01E",
        "#FFAA28",
        "#FFB432",
        "#FFB937",
        "#FFBE3C",
        "#FFC341",
        "#FFC846",
        "#FFA98F",
        "#FFB399",
        "#FFBDA3",
        "#FFC7AD",
        "#FFD1B7",
        "#FFDBC1",
        "#FFE0C6",
        "#FFE5CB",
        "#FFEAD0",
        "#FFEFD5",
        "#FFA374",
        "#FFAD7E",
        "#FFB788",
        "#FFC192",
        "#FFCB9C",
        "#FFD0A1",
        "#FFD5A6",
        "#FFDAAB",
        "#FFDFB0",
        "#FFE4B5",
        "#FF9473",
        "#FF9E7D",
        "#FFA887",
        "#FFB291",
        "#FFBC9B",
        "#FFC6A5",
        "#FFD0AF",
        "#FFD0AF",
        "#FFD5B4",
        "#FFDAB9",
        "#FF7F50",
        "#FF895A",
        "#FF9364",
        "#FF9D6E",
        "#FFA778",
        "#FFB182",
        "#FFBB8C",
        "#FFC091",
        "#FFC596",
        "#FFCA9B",
      ],
      timer: "",
    };
  },
  mounted() {
    this.startBG();
  },
  beforeDestroy() {
    document.body.style.background = "#f8f8f8";
    clearInterval(this.timer);
  },
  methods: {
    startBG() {
      this.timer = setInterval(() => {
        let mycolor = this.generator();
        document.body.style.background = mycolor;
      }, 2500);
    },
    loginWithFacebook() {
      this.$store.dispatch("auth/loginWithFacebook", {
        notify: this.$vs.notify,
      });
    },
    generator: function () {
      var item = this.mycolor[Math.floor(Math.random() * this.mycolor.length)];
      return item;
    },
  },
  created() {
    document.body.style.background = this.mycolor[21];
  },
};
</script>

<style lang="scss" scoped>
.login-tabs-container {
  min-height: 200px;

  .con-tab {
    padding-bottom: 14px;
  }

  .con-slot-tabs {
    margin-top: 1rem;
  }
}
.social-login-buttons {
  .bg-facebook {
    background-color: #1551b1;
  }
}
</style>
